import * as GetPaymentTypes from 'src/actions/payment/get/Types';
import {
  GetPaymentAction,
  GetPaymentSuccess
} from 'src/actions/payment/get/GetPayment.actions';
import Payment from 'src/entities/Payment';

export interface GetPaymentState {
  payment?: Payment;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetPaymentState = {
  loading: false,
  error: false,
  payment: undefined,
  errorMessage: {}
};

export function GetPaymentReducer(
  state: GetPaymentState = initialState,
  action: GetPaymentAction): GetPaymentState {
  switch (action.type) {
    case GetPaymentTypes.GET_PAYMENT_ATTEMPT:
      return {...state, payment: undefined, loading: true, error: false};
    case GetPaymentTypes.GET_PAYMENT_SUCCESS:
  
      const payment: Payment = (action as GetPaymentSuccess).payload;
      return {
        ...state,
        payment: payment,
        loading: false,
        error: false
      };
    case GetPaymentTypes.GET_PAYMENT_FAILURE:
      return {...state, payment: undefined,  loading: false, error: true};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/payment/GetPaymentReducer.tsx